import { ProfileCompletion, PointOfSale, ModelLanguage } from '@dynameat/models';
import * as MutationTypes from '../mutationTypes';
import * as api from '../api';

export const profileCompletionListRequest = async ({
  commit,
  getters: { profileCompletionList }
}, pointOfSaleGuid) => {
  if (profileCompletionList.length === 0) {
    const response = await api.profileCompletionListRequest(pointOfSaleGuid);
    const profileList = ProfileCompletion.toInstanceList(response.data.results);
    commit(MutationTypes.PROFILE_COMPLETION_LIST_SUCCESS, profileList);
  }
};

export const pointOfSaleListRequest = async ({ commit }) => {
  const response = await api.pointOfSaleListRequest();
  const pointOfSaleList = PointOfSale.toInstanceList(response.data);
  commit(MutationTypes.POINT_OF_SALE_LIST_SUCCESS, pointOfSaleList);
  return pointOfSaleList;
};

export const modelLanguageRequest = async ({ commit }) => {
  const response = await api.modelLanguageRequest();
  const modelLanguageList = ModelLanguage.toInstanceList(response.data.results);
  commit(MutationTypes.MODEL_LANGUAGE_LIST_SUCCESS, modelLanguageList);
  return modelLanguageList;
};

export const setSelectedPointOfSaleGuid = ({ commit }, pointOfSaleGuid) => commit(MutationTypes.SET_SELECTED_POINT_OF_SALE_GUID, pointOfSaleGuid);

export const setModuleStatus = ({ commit }, status) => commit(MutationTypes.MODULE_STATUS, status);
